<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/jschicheng/production/schedule/config/page" getKey="rows" :columns="columns">
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary" v-if="utils.checkPower('web_production_management_schedule_config_create')">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="utils.checkPower('web_production_management_schedule_config_update')">
            <el-button type="text" :loading="yt.editObj.loading" @click="yt.showEditDialog('bianji', scope.row, 'w1')">
              {{ $t("bianji") }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="utils.checkPower('web_production_management_schedule_config_delete')">
            <el-button type="text" :loading="yt.editObj.loading" class="font-color-danger" @click="yt.remove(scope.row, '/custom/jschicheng/production/schedule/config/delete',null,'确定删除该条排班配置吗？删除后不可恢复，且看板对应数据将同步移除')">{{ $t("shanchu") }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增弹窗-->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('shengchangongdanhao')" required>
            <yi_cross_select :max="1" :component="'web_quality_management_work_order'" :selectTitle="'wo.no'" :fixConditions="{ woStatusList: ['3'] }" @getItems="getItems" :ids.sync="yt.editObj.woId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('shebeibianhao')" required>
            <yi_data_select :type="'equipment'" :ids.sync="yt.editObj.equipmentId" disabled></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('banciriqi')" required>
            <yi_time_input :format="'yyyy-MM-dd'" type="date" :time.sync="yt.editObj.shiftDate"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('dingdanjiaofuriqi')">
            <yi_time_input :format="'yyyy-MM-dd'" type="date" :time.sync="yt.editObj.orderDeliveryDate"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('zaobanrenyuan')">
            <el-input v-model="yt.editObj.firstShiftUser"></el-input>
          </el-form-item>
          <el-form-item :label="$t('wanbanrenyuan')">
            <el-input v-model="yt.editObj.secondShiftUser"></el-input>
          </el-form-item>
          <el-form-item :label="$t('banchanmo')">
            <el-input-number v-model="yt.editObj.shiftProduction" :precision="2" :step="0.01" :min="0" size="mini" controls-position="right" placeholder="请输入，保留2位小数"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('zhuyishixiangguanzhu')">
            <el-input type="textarea" v-model="yt.editObj.attention" maxlength="200" placeholder="请输入，最多200字符"> </el-input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" v-model="yt.editObj.remark" maxlength="200" placeholder="请输入，最多200字符"> </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/custom/jschicheng/production/schedule/config/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 编辑弹窗-->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('shengchangongdanhao')" required>
            <el-input v-model="yt.editObj.wo.no" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeibianhao')" required>
            <yi_data_select :type="'equipment'" :ids.sync="yt.editObj.equipmentId" disabled></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('banciriqi')" required>
            <yi_time_input :format="'yyyy-MM-dd'" type="date" :time.sync="yt.editObj.shiftDate"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('dingdanjiaofuriqi')">
            <yi_time_input :format="'yyyy-MM-dd'" type="date" :time.sync="yt.editObj.orderDeliveryDate" clearable></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('zaobanrenyuan')">
            <el-input v-model="yt.editObj.firstShiftUser"></el-input>
          </el-form-item>
          <el-form-item :label="$t('wanbanrenyuan')">
            <el-input v-model="yt.editObj.secondShiftUser"></el-input>
          </el-form-item>
          <el-form-item :label="$t('banchanmo')">
            <el-input-number v-model="yt.editObj.shiftProduction" :precision="2" :step="0.01" :min="0" size="mini" controls-position="right" placeholder="请输入，保留2位小数" clearable></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('zhuyishixiangguanzhu')">
            <el-input type="textarea" v-model="yt.editObj.attention" maxlength="200" placeholder="请输入，最多200字符"> </el-input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" v-model="yt.editObj.remark" maxlength="200" placeholder="请输入，最多200字符"> </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/custom/jschicheng/production/schedule/config/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_production_management_production_schedule_config_jschicheng_list',
  data() {
    return {
      columns: [
        {
          label: 'shengchangongdanhao',
          prop: 'wo.no',
          width: 200
        },
        {
          label: 'shebeibianhao',
          prop: 'equipment.name',
          width: 130
        },
        {
          label: 'banciriqi',
          prop: 'shiftDate',
          type: 'time',
          width: 130,
          format: 'YYYY-MM-DD'
        },
        {
          label: 'zaobanrenyuan',
          prop: 'firstShiftUser',
        },
        {
          label: 'wanbanrenyuan',
          prop: 'secondShiftUser',
        },
        {
          label: 'dingdanjiaofuriqi',
          prop: 'orderDeliveryDate',
          type: 'time',
          width: 130,
          format: 'YYYY-MM-DD'
        },
        {
          label: 'banchanmo',
          prop: 'shiftProduction',
          formatter: (scope) => {
            const val = scope.row.shiftProduction;
            if (val === null || val === undefined || val === '') return '';
            const num = parseFloat(val);
            return isNaN(num) ? '' : num.toFixed(2);
          }
        },
        {
          label: 'zhuyishixiangguanzhu',
          prop: 'attention',
          width: 180,
        },
        {
          label: 'beizhu',
          prop: 'remark',
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 100,
          fixed: 'right'
        }
      ],
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.$refs.yt) {
        this.$refs.yt.get(1);
      }
    });
  },
  methods:{
    getItems(items) {
      if (!items) return;
      console.log(items)
      this.yt.editObj.woId = items.woId;
      this.yt.editObj.equipmentId = items.equipmentId;
      this.yt.editObj.materialIds = items.materialId;
    },
  }
}
</script>
<style scoped lang="scss">

</style>